export const ItemsCategoryColumns = [
  {
    Header: "Department",
    accessor: "department_name",
    id: "department_name",
    sortable: true,
    filterable: true,
    Cell: ({ value }) => (
      <div className="text-truncate" title={value}>
        {value}
      </div>
    ),
  },
  {
    Header: "Category",
    accessor: "category_name",
    id: "category_name",
    sortable: true,
    filterable: true,
    Cell: ({ value }) => (
      <div className="text-truncate" title={value}>
        {value}
      </div>
    ),
  },
  {
    Header: "Requested By",
    accessor: "requested_by",
    id: "requested_by",
    sortable: true,
    filterable: true,
    Cell: ({ value }) => (
      <div className="text-truncate" title={value}>
        {value}
      </div>
    ),
  },
  // {
  //   Header: "Status",
  //   accessor: "status",
  //   id: "status",
  //   sortable: true,
  //   filterable: true,
  //   Cell: ({ value }) => {
  //     const getStatusBadge = (status) => {
  //       switch (status?.toLowerCase()) {
  //         case "approved":
  //           return "badge bg-success"
  //         case "rejected":
  //           return "badge bg-danger"
  //         case "pending":
  //           return "badge bg-warning text-dark"
  //         default:
  //           return "badge bg-secondary"
  //       }
  //     }

  //     return <span className={getStatusBadge(value)}>{value?.charAt(0)?.toUpperCase() + value?.slice(1)}</span>
  //   },
  // },
  // {
  //   Header: "Created Date",
  //   accessor: "created_at",
  //   id: "created_at",
  //   sortable: true,
  //   filterable: true,
  //   Cell: ({ value }) => <div className="text-nowrap">{value}</div>,
  // },
  {
    Header: "Invoices",
    accessor: "invoice_file",
    id: "invoice_file",
    sortable: false,
    filterable: false,
    Cell: ({ value, row }) => {
      return <div className="text-start">{value}</div>
    },
  },
  {
    Header: "Request Type",
    accessor: "request_type",
    id: "request_type",
    sortable: false,
    filterable: false,
    Cell: ({ value }) => <div className="text-start">{value}</div>,
  },
  {
    Header: "Items",
    accessor: "items",
    id: "items",
    sortable: false,
    filterable: false,
    Cell: ({ value }) => <div className="text-start">{value}</div>,
  },
  {
    Header: "Request Status",
    accessor: "request_actions",
    id: "request_actions",
    sortable: false,
    filterable: false,
    Cell: ({ value }) => <div className="text-center" style={{width:'176px'}}>{value}</div>,
  },
  {
    Header: "Actions",
    accessor: "actions",
    id: "actions",
    sortable: false,
    filterable: false,
    Cell: ({ value }) => <div className="text-center">{value}</div>,
  },
]
